var map = {
	"./logo_1.jpg": "4a19",
	"./logo_2.jpg": "970e",
	"./logo_3.jpg": "a758",
	"./logo_4.jpg": "1239",
	"./logo_5.jpg": "dbd0",
	"./logo_6.jpg": "f950",
	"./logo_7.jpg": "9bb9",
	"./logo_8.jpg": "d119",
	"./logo_9.jpg": "96ed"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "328b";